<template>
  <div class="data_erase_application_form">
    <div>
      <button class="printBtn" @click="print()">印刷する</button>

      <body v-for="i in applyInfo['erasePcNum']" v-bind:key="i" class="print">
        <div class="print_assist">
          <div class="print_title">
            “おまかせ”安全消去サービス　申込書
          </div>
          <div class="print_msg_area">
            <p>※パソコン１台につき１枚の申込書をご記入ください。</p>
            <div class="apply_info">
              <table class="apply_info_tbl">
                <tr>
                  <th>申込ID</th>
                  <td>{{ applyInfo['applyId'] }}</td>
                </tr>
                <tr class="tr_end">
                  <th>お名前<span>（必須）</span></th>
                  <td></td>
                </tr>
              </table>
            </div>
            <div class="apply_info2">
              <table class="apply_info_tbl">
                <tr>
                  <th>メーカー名<span>（必須）</span></th>
                  <td></td>
                </tr>
                <tr>
                  <th>型番<span>（任意）</span></th>
                  <td></td>
                </tr>
                <tr class="tr_end">
                  <th>台数</th>
                  <td>{{ i }}台目 / 合計{{ applyInfo['erasePcNum'] }}台</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="print_mid_title">
            プリンタをお持ちでない方へ
          </div>
          <div class="print_msg_area">
            <p class="print_mid_msg">手書きで申込書をご用意ください。</p>
            <ul class="print_mid_msg_detail">
              <li>・申込書には、「申込ID」「お名前」「メーカー名（必須）」「型番（任意）」「台数」をご記入ください。</li>
              <li>・メモ用紙等あまり小さな紙ではなく、A4コピー用紙や、便箋等をご用意ください。</li>
            </ul>
          </div>
          <div class="print_mid_title">
            ご注意事項
          </div>
          <div class="print_msg_area">
            <div class="mod-box-imgTxt1">
              <div class="imgBox">
                <img :src="img_sample" width="159" height="115" alt="">
              </div>
              <ul class="print_mid_msg_detail">
                <li>・1台につき1枚、申込書をご用意ください。</li>
                <li>・消去をご希望されるパソコン本体へ、申込書をテープで留めてください。</li>
                <li>・申込書に記入漏れがある場合や、パソコン本体にテープ留めされていない場合は、データ消去のお申し込みをいただいてもデータ消去証明書の発行が出来ないことがございますのでご了承ください。
                </li>
              </ul>
            </div>
          </div>
          <div class="print_footer">
            <div class="mod-box-imgTxt2">
              <div class="com_image">
                <img :src="img_logo" height="50" alt="ReNet.jp">
              </div>
              <div class="com_image">
                <img :src="img_waste" height="50" alt="E-Waste 小型家電 大臣認定 第0024号">
              </div>
              <div class="com_info">
                <dl class="txtBox">
                  <dt>リネットジャパンリサイクル株式会社</dt>
                  <dd>
                    小型家電リサイクル法 認定番号 第24号
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </body>
    </div>
  </div>
</template>


<script>
import constant from '../../js/constant'
export default {
  props: {
  },
  data() {
    return {
      applyInfo: {},
      msgDispFlg: false,
      img_sample: constant.IMAGE_SAMPLE_SP,
      img_logo: constant.IMAGE_LOGO_SP,
      img_waste: constant.IMAGE_WASTE_SP,
    }
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    this.applyInfo = JSON.parse(decodeURIComponent(params.get('applicationFormParams')));
  },
  methods: {
    // 印刷ダイアログ表示
    print() {
      window.print();
    }
  },
}

</script>